/**
 * @fileoverview Main entry point for the MemoTrack React frontend application.
 * Initializes Firebase remote config, mounts the root React component into the DOM,
 * registers Firebase messaging service workers, and hooks web vitals performance monitoring.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MemoTrackApp from './App';
import reportWebVitals from './reportWebVitals';

import { initRemoteConfig } from './config/remoteConfig';

// Initialize remote config before the app fully boots
initRemoteConfig().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
        <MemoTrackApp />
    </React.StrictMode>
  );
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then(registration => {

    })
    .catch(err => {
      console.error('SW registration failed:', err);
    });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
